export enum ChannelType {
    DM = 'D',
    PUBLIC = 'O',
    PRIVATE = 'P',
    GM = 'G',
}

export type UserStatus = 'online' | 'away' | 'dnd' | 'offline' | 'ooo';
